module.exports = __webpack_public_path__ + "img/icon4.c6f92d06.png";